// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exibir {\n  display: block;\n}\n\n.noExibir {\n  display: none !important;\n}", "",{"version":3,"sources":["webpack://src/pages/relatorios/relatorioProcesso.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".exibir {\n  display: block;\n}\n\n.noExibir {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
